<script lang="ts">
  import { twMerge } from 'tailwind-merge';
  import Eye from '../../../assets/svgs/eye.svelte';
  import EyeOff from '../../../assets/svgs/eye-off.svelte';

  export let label: string;
  export let error: string | boolean | undefined = undefined;
  export let customClass: string | undefined = '';
  let trackingClass = '';
  export let plausibleClass: 'firstName' | 'lastName' | 'dob' | 'email' | 'password' | string = '';
  export let value: string;
  export let animateLabel: boolean = true;
  let input: HTMLInputElement;
  let isFocused = false;
  let placeholder = label;

  const inputClass = `w-full h-12 md:h-14 px-3 py-2 rounded-sm border border-gray-100 bg-gray-100 focus:ring-0 focus:border-gray-900 transition-all`;
  let errorClass = '';
  let labelClass = 'animate-label';

  $: if (error) {
    errorClass = 'border-error-500 focus:border-error-500';
  } else {
    errorClass = '';
  }

  $: if (animateLabel) {
    labelClass = 'animate-label';
  } else {
    labelClass = '';
  }

  $: switch (plausibleClass) {
    case 'firstName':
      trackingClass = 'plausible-event-name=new_paywall_select_firstname';
      break;
    case 'lastName':
      trackingClass = 'plausible-event-name=new_paywall_select_lastname';
      break;
    case 'dob':
      trackingClass = 'plausible-event-name=new_paywall_select_dob';
      break;
    case 'email':
      trackingClass = 'plausible-event-name=new_paywall_select_email';
      break;
    case 'password':
      trackingClass = 'plausible-event-name=new_paywall_select_password';
      break;
  }

  // Fix because Safari does not allow placeholder for date types
  $: isDate = $$restProps.type === 'date';
  $: shouldHidePlaceholder = (isDate && (isFocused || !!value)) || !isDate;

  // For password showing and hiding
  $: isPassword = $$restProps.type === 'password';

  $: mergedClass = twMerge(inputClass, errorClass, labelClass, customClass);
</script>

<div class="relative">
  <div class="relative">
    <input
      bind:this={input}
      bind:value
      on:focus={() => (isFocused = true)}
      on:blur={() => (isFocused = false)}
      class={`${trackingClass} ${mergedClass} ${!shouldHidePlaceholder ? 'placeholder-hidden' : ''}`}
      {placeholder}
      {...$$restProps}
    />
    {#if animateLabel || isDate}
      <span
        class={`${
          shouldHidePlaceholder ? 'hidden' : ''
        } md:block text-gray-500 pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 transition-all`}
        >{label}</span
      >
    {/if}

    {#if isPassword && value}
      <button
        type="button"
        class="absolute top-1/2 right-3 -translate-y-1/2"
        on:click={() => {
          input.type = input.type === 'password' ? 'text' : 'password';
        }}
      >
        {#if input.type === 'password'}
          <Eye customClass="w-5 h-5" />
        {:else}
          <EyeOff customClass="w-5 h-5" />
        {/if}
      </button>
    {/if}
  </div>

  <slot />

  {#if error && typeof error === 'string'}
    <p class="text-error-500 text-sm mt-1">{error}</p>
  {/if}
</div>

<style>
  input.placeholder-hidden::-webkit-datetime-edit {
    color: transparent !important;
  }

  @media (min-width: 768px) {
    input:not(:placeholder-shown) + span {
      transform: translateY(calc(-50% - 0.75rem));
      font-size: 12px;
    }

    input.placeholder-hidden::-webkit-datetime-edit {
      color: black !important;
    }

    input.animate-label:not(:placeholder-shown) {
      padding-top: 1.5rem;
      padding-bottom: 0.75rem;
    }

    .animate-label::placeholder {
      color: transparent;
    }
  }
</style>
